import { createAction, handleActions } from 'redux-actions'

// 타입 정의
export const SET_BRANCH_INFO = 'auth/SET_BRANCH_INFO';
export const SET_BRANCH_EXCHANGE_RATE = 'auth/SET_BRANCH_EXCHANGE_RATE';
export const setBranchInfo = createAction(
  SET_BRANCH_INFO,
  (branchInfo) =>{
      return branchInfo
  }
)
export const setBranchExchangeRate = createAction(
  SET_BRANCH_EXCHANGE_RATE,
  (exchangeRate) =>{
      return exchangeRate
  }
)

// 초기 상태값
const initialState = {
    bannerInfo: [],
    companyInfo: "",
    csInfo: {
      email: "",
      inquery: {
        text: "",
        link: ""
      },
      account_email: "",
      deposit_email: "",
      text: ""
    },
    mypage_banner: "",
    siteInfo : {
      topColor : "",
      topFontColor : ""
    },
    partnerInfo:{
      pm_name:""
    },
    operationInfo:{},
    term : "",
    personal : "",
    branchRateCode: "",
    branchRate: 0,
    pm_otp_name: "",
  }

// 리듀서 내보내기
export default handleActions({
  [SET_BRANCH_INFO]:(state, {payload}) => {
      return {
          ...state,
          ...payload,
      }
  },[SET_BRANCH_EXCHANGE_RATE]:(state, {payload}) => {
    return {
        ...state,
        branchRate:payload,
    }
  }
}, initialState);
